import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeIconModule, seFeIconSpotJersey } from 'se-fe-icon'
import { SeFeSpinnerModule } from 'se-fe-spinner'
import { SharedUiChildContactInfoModule } from '@se-po/shared-ui-child-contact-info'
import { SharedUiHighlightLabelModule } from '@se-po/shared-ui-highlight-label'

import { AddChildContactInfoComponent } from './add-child-contact-info/add-child-contact-info.component'

@NgModule({
  declarations: [AddChildContactInfoComponent],
  exports: [AddChildContactInfoComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeButtonModule,
    SeFeIconModule.include([seFeIconSpotJersey]),
    SeFeSpinnerModule,
    SharedUiChildContactInfoModule,
    SharedUiHighlightLabelModule,
  ],
})
export class SharedUiAddChildContactInfoModule { }
